import { Text, Tooltip } from "@mantine/core";
import {
  addHoursToDate,
  getTimezoneOffset,
  parseDate,
} from "../../../functions/dates";
import { useLanguage } from "../../../stores/LanguageStore";
import { useProfileStore } from "../../../stores/UserStore";

const dateColumn = ({
  field = "created_on",
  headerName,
  preferEmpty,
  others,
  emptyCondition,
  withTimezone,
  sortable = true,
  filterable = false,
  flex,
} = {}) => {
  return {
    field: field,
    headerName:
      headerName ||
      useLanguage.getState().language.table.default_columns.created_on_name,
    width: 135,
    filterable,
    sortable,
    id: field,
    flex,
    valueGetter: (params) => {
      return params?.value || "";
    },
    renderCell: (cell) => {
      let timezone = useProfileStore.getState().profile?.timezone;
      let value =
        withTimezone && cell?.value
          ? addHoursToDate(
              cell.value,
              -getTimezoneOffset() + new Date().getTimezoneOffset() / 60
            )
          : cell.value;
      if (emptyCondition) {
        if (emptyCondition(cell.row)) {
          return "-";
        }
      }
      if (value)
        return (
          <Tooltip
            label={`${new Date(value)?.toLocaleString()} ${
              timezone ? `(${timezone})` : ""
            }  `}
            withArrow
            openDelay={500}
          >
            <Text truncate="end">{parseDate(cell.value, true)}</Text>
          </Tooltip>
        );
      else return preferEmpty ? "" : "-";
    },
    ...others,
  };
};

export default dateColumn;
